/*
  FX-RUTINA · botón «Agregar» de «Completa tu rutina» en el carrito (21-oct-2026).
  El HTML lo pinta snippets/fx-carrito-rutina.liquid. Aquí solo va el clic, por delegación,
  porque el cajón se vuelve a pintar con innerHTML cada vez que cambia el carrito.
  · En el cajón: /cart/add.js con sections y renderContents() de cart-drawer.js, igual que la ficha.
  · En /cart: recarga la página (ahí no hay cajón que repintar).
  Mira res.ok: si Shopify dice que no (agotado, límite), el botón lo dice y no finge éxito.
*/
(function () {
  if (window.__fxRutina) return;
  window.__fxRutina = true;

  document.addEventListener('click', async function (event) {
    var boton = event.target.closest('[data-fx-rutina-add]');
    if (!boton || boton.disabled) return;
    event.preventDefault();

    var id = Number(boton.getAttribute('data-fx-rutina-add'));
    var texto = boton.textContent;
    var cajon = document.querySelector('cart-drawer');
    var enCajon = !!(cajon && boton.closest('cart-drawer') && typeof cajon.renderContents === 'function');

    boton.disabled = true;
    boton.setAttribute('aria-busy', 'true');
    boton.textContent = 'Agregando…';

    try {
      var cuerpo = { items: [{ id: id, quantity: 1 }] };
      if (enCajon) {
        cuerpo.sections = 'cart-drawer,cart-icon-bubble';
        cuerpo.sections_url = window.location.pathname;
      }
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      var res = await fetch(base + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(cuerpo),
      });
      var datos = await res.json();
      if (!res.ok || datos.status) throw new Error(datos.description || datos.message || 'No se pudo agregar');

      if (enCajon && datos.sections) {
        cajon.renderContents({ id: id, sections: datos.sections });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fx-rutina', productVariantId: id });
        }
      } else {
        window.location.reload();
      }
    } catch (e) {
      boton.textContent = 'No se pudo agregar';
      boton.removeAttribute('aria-busy');
      setTimeout(function () {
        boton.textContent = texto;
        boton.disabled = false;
      }, 2500);
    }
  });
})();
